import { ReactElement } from "react";
import { FiLoader } from "react-icons/fi";

export default function PageLoadingScreen(): ReactElement {
    return (
        <div
            data-testid="page-loading-screen"
            role="status"
            aria-label="Loading"
            className="flex w-full h-dvh grow items-center justify-center bg-brand-lightGray"
        >
            <FiLoader size={24} className="animate-spin" />
        </div>
    );
}
